module.exports = __webpack_public_path__ + "img/currencyFooter.f913930a.svg";